<template>
  <div class="center">
    <q-card class="my-card-reg-externo">
      <q-card-section class="card_titulo">
        <div class="card_titulo_text">Registrarse</div>
      </q-card-section>
      <q-card-actions align="around">
        <div class="flex-item_30">
          <q-icon name="info" />* Dato Obligatorio
        </div>
        <div class="flex-item_60"></div>
        <div class="flex-item_30">
          <q-field borderless ref="nombre">
            <q-input
              v-model="v$.Nombre.$model"
              maxlength="30"
              dense
              input-debounce="0"
              :error="v$.Nombre.$error"
              label="*Nombre"
              class="col-12"
            >
              <template v-slot:error>Dato obligatorio.</template>
            </q-input>
          </q-field>
        </div>
        <div class="flex-item_50">
          <q-field borderless ref="apellidos">
            <q-input
              v-model="v$.Apellidos.$model"
              maxlength="50"
              dense
              input-debounce="0"
              :error="v$.Apellidos.$error"
              label="*Apellidos"
              class="col-12"
            >
              <template v-slot:error>Dato obligatorio.</template>
            </q-input>
          </q-field>
        </div>
        <!-- CAMPO  Tfno -->
        <div class="flex-item_20">
          <q-field borderless ref="telefono">
            <q-input
              v-model="v$.Telefono.$model"
              maxlength="15"
              dense
              input-debounce="0"
              :error="v$.Telefono.$error"
              :rules="[val => validateTfno(val)  || 'Teléfono no válido']"
              label="*Teléfono"
              class="col-12"
            >
              <template v-slot:error>Dato obligatorio.</template>
            </q-input>
          </q-field>
        </div>
        <div class="flex-item_40">
          <q-field borderless ref="field">
            <q-input
              v-model="v$.Empresa.$model"
              required
              maxlength="50"
              dense
              input-debounce="0"
              :error="v$.Empresa.$error"
              type="N"
              label="*Empresa"
              class="col-12"
            >
              <template v-slot:error>Dato obligatorio.</template>
            </q-input>
          </q-field>
        </div>
        <div class="flex-item_40">
          <q-field borderless ref="email">
            <q-input
              v-model="v$.Email.$model"
              required
              maxlength="50"
              dense
              input-debounce="0"
              :error="v$.Email.$error"
              :rules="[val => validateEmail(val)  || 'Correo electrónico no válido']"
              label="*Correo Electrónico"
              class="col-12"
            >
              <template v-slot:error>Email no válido.</template>
            </q-input>
          </q-field>
        </div>
        <div class="flex-item_10"></div>
        <div class="flex-item_40">
          <q-field borderless ref="contraseña">
            <q-input
              minlength="6"
              maxlength="100"
              hint="6 caracteres mínimo. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
              dense
              input-debounce="0"
              :error="v$.Contraseña.$error"
              :rules="[val => (validatePassword(val))  || 'Contraseña no válida. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula']"
              class="col-12"
              ref="contraseña"
              v-model="v$.Contraseña.$model"
              :type="isPwd ? 'password' : 'text'"
              label="*Contraseña"
              bottom-slots
            >
              <template
                v-slot:error
              >Dato Obligatorio. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula.</template>
              <template v-slot:append>
                <q-icon
                  :name="isPwd ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer"
                  @click="isPwd = !isPwd"
                />
              </template>
            </q-input>
          </q-field>
        </div>
        <!-- CAMPO  recordar contraseña -->
        <div class="flex-item_40">
          <q-field borderless ref="repetir_contraseña">
            <q-input
              minlength="6"
              required
              maxlength="100"
              hint="6 caracteres mínimo. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
              dense
              input-debounce="0"
              :error="v$.RepetirContraseña.$error"
              :rules="[val => (val===this.Contraseña)  || 'Las contraseñas deben coincidir',
                      val => (validatePassword(val))  || 'Contraseña no válida. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula']"
              class="col-12"
              ref="repetir_contraseña"
              v-model="v$.RepetirContraseña.$model"
              :type="isPwd ? 'password' : 'text'"
              label="*Confirmar Contraseña"
              bottom-slots
            >
              <template
                v-slot:error
              >Dato Obligatorio. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula.</template>
              <template v-slot:append>
                <q-icon
                  :name="isPwd ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer"
                  @click="isPwd = !isPwd"
                />
              </template>
            </q-input>
          </q-field>
        </div>
        <div class="flex-item_10"></div>
      </q-card-actions>
      <q-card-actions align="right">
        <q-btn title="atrás" @click="atras" class="ma-2" text-color="black" color="lime-2">atrás</q-btn>
        <q-btn
          title="enviar datos usuario"
          @click="validar_usuario"
          class="ma-2"
          text-color="black"
          color="lime"
          :disabled="isDisabled"
        >enviar</q-btn>
      </q-card-actions>
    </q-card>
  </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
// import ValidationResponseHandler from '@/components/shared/mixins/ValidationResponseHandler.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';

import { QInput, QCard, QField, QCardSection, QCardActions } from 'quasar';

export default {
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      isPwd: true,
      Nombre: null,
      Apellidos: null,
      Empresa: null,
      Telefono: null,
      Email: null,
      Contraseña: null,
      RepetirContraseña: null
    };
  },
  mixins: [Loading, Message, Validation],
  validations: {
    Nombre: { required },
    Apellidos: { required },
    Empresa: { required },
    Telefono: { required },
    Email: { required },
    Contraseña: { required },
    RepetirContraseña: { required }
  },
  methods: {
    atras () {
      this.$router.push({ name: '/' });
    },
    validar_usuario () {
      this.v$.$touch();
      if (this.v$.$error) {
        this.showError('Deben introducirse correctamente todos los datos.');
      } else if (this.comprobar_datos_usuario_externo()) {
        this.showLoading();

        let bodyParams = {
          user: {
            user: {
              mail: this.Email,
              isExternal: true,
              password: this.Contraseña
            },
            profile: {
              nombre: this.Nombre,
              Apellidos: this.Apellidos,
              empresa: this.Empresa,
              telefono: this.Telefono
            }
          }
        };

        let request = {
          controller: '/AnonymousUser',
          filter: {},
          body: bodyParams
        };

        this.$store
          .dispatch('PF/postSuit', request)
          .then(response => {
            this.showMessage('Para continuar el proceso debe validar el enlace enviado a su correo electrónico.');
          })
          .catch(err => {
            this.showError(err.message);
          });

        this.hideLoading();
      } else {
        this.showError('Deben introducirse correctamente todos los datos.');
      }
    },
    comprobar_datos_usuario_externo () {
      if (
        this.myTrim(this.Nombre) === '' ||
        this.myTrim(this.Empresa) === '' ||
        this.myTrim(this.Email) === '' ||
        this.myTrim(this.Contraseña) === '' ||
        this.myTrim(this.Telefono) === '' ||
        this.myTrim(this.RepetirContraseña) === '' ||
        !this.validateTfno(this.myTrim(this.Telefono)) ||
        !this.validatePassword(
          this.myTrim(this.Contraseña)
        ) ||
        !this.validatePassword(
          this.myTrim(this.RepetirContraseña)
        ) ||
        this.myTrim(this.RepetirContraseña) !==
          this.myTrim(this.Contraseña) ||
        !this.validateEmail(this.myTrim(this.Email))
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  computed: {
    isDisabled: function () {
      let disabledButton = true;

      if (
        (this.Nombre !== '' && this.Nombre !== null) &&
        (this.Apellidos !== '' && this.Apellidos !== null) &&
        (this.Empresa !== '' && this.Empresa !== null) &&
        (this.Email !== '' && this.Email !== null) &&
        (this.Telefono !== '' && this.Telefono !== null) &&
        (this.Contraseña !== '' && this.Contraseña !== null) &&
        (this.RepetirContraseña !== '' && this.RepetirContraseña !== null)
      ) {
        if (this.comprobar_datos_usuario_externo()) {
          disabledButton = false;
        }
      }

      return disabledButton;
    }
  },
  components: {
    QInput,
    QCard,
    QField,
    QCardSection,
    QCardActions
  }
};
</script>
